import { Country } from '@spartacus/core';
import { SiteContextActions } from '../actions/index';
import { CountryState } from '../state';

export const initialState: CountryState = {
  entities: null,
  activeCountry: null,
};

export function reducer(
  state = initialState,
  action: SiteContextActions.CountryAction
): CountryState {
  switch (action.type) {
    case SiteContextActions.LOAD_COUNTRY_SUCCESS: {
      const countries: Country[] = action.payload;
      const entities = countries.reduce(
        (langEntities: { [isocode: string]: Country }, country: Country) => {
          return {
            ...langEntities,
            [country.isocode ?? '']: country,
          };
        },
        {
          ...state.entities,
        }
      );

      return {
        ...state,
        entities,
      };
    }

    case SiteContextActions.SET_ACTIVE_COUNTRY: {
      const isocode = action.payload;

      return {
        ...state,
        activeCountry: isocode,
      };
    }
  }
  return state;
}
